import React from "react";

import { useTranslation } from "react-i18next";

import { WillBothTeamsScore } from "@data-types/sport-stats/SportStatsTypes";
import RecentGames from "../RecentGames";

import Graph from "../Graph";

export default function WillBothTeamsScoreStatistics(props: {
	homeTeam: WillBothTeamsScore["data"];
	awayTeam: WillBothTeamsScore["data"];
}) {
	const { t } = useTranslation();

	return (
		<>
			<RecentGames
				homeTeamEventCount={props.homeTeam?.eventCount}
				awayTeamEventCount={props.awayTeam?.eventCount}
			/>

			<Graph
				title={t("EVENT.STATISTICS.BETTING_TYPE_STATS.CLEAN_SHEETS")}
				home={t("OFFER.COMPETITORS.HOME")}
				away={t("OFFER.COMPETITORS.AWAY")}
				data={{
					homeValue: props.homeTeam?.cleanSheets,
					awayValue: props.awayTeam?.cleanSheets,
				}}
				isPercentage
			/>

			<Graph
				title={t(
					"EVENT.STATISTICS.BETTING_TYPE_STATS.AT_LEAST_ONE_GOAL"
				)}
				home={t("OFFER.COMPETITORS.HOME")}
				away={t("OFFER.COMPETITORS.AWAY")}
				data={{
					homeValue: props.homeTeam?.atLeastOneGoalScored,
					awayValue: props.awayTeam?.atLeastOneGoalScored,
				}}
				isPercentage
			/>
		</>
	);
}
